import { Link } from "react-router-dom";
import { stats } from "@/mocks/stats";
import { leads } from "@/mocks/leads";

const tickerItems = leads.slice(0, 6).map((lead) => `${lead.title} · 悬赏 ¥${lead.bounty}`);

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950" aria-label="线索征集令">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dramatic%20dark%20editorial%20city%20scene%20at%20night%20in%20rain%20with%20blurred%20skyline%20glow%2C%20amber%20and%20crimson%20light%20streaks%2C%20a%20single%20spotlight%20beam%20cutting%20through%20mist%2C%20cinematic%20noir%20atmosphere%2C%20abstract%20documentary%20background%2C%20no%20text%2C%20high%20contrast&width=1600&height=1000&seq=baoliao51-hero-main&orientation=landscape"
          alt="爆料51 线索征集平台夜景氛围背景"
          title="爆料51 线索征集 - 全网悬赏征集令"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/85" />

      <div className="relative mx-auto w-full max-w-7xl px-4 py-20 md:px-8 md:py-28">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-foreground-950/40 px-3 py-1.5 text-xs font-medium text-accent-300 backdrop-blur">
            <span className="live-dot h-2 w-2 rounded-full bg-primary-400" />
            全网征集令进行中 · 悬赏通道已开启
          </span>

          <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-background-50 text-balance md:text-5xl lg:text-6xl">
            有线索你就来
            <span className="mt-2 block text-accent-400">让真相浮出水面</span>
          </h1>

          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            爆料51 面向全网发布线索征集令，围绕民生、消费、环境、财经等公共议题持续收集真实信息。
            只要你掌握有价值的线索，就可以匿名提交，由核实团队对接跟进。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/submit"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-megaphone-line" />
              立即提供线索
            </Link>
            <Link
              to="/bounty"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-200/40 px-6 py-3 text-sm font-medium text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
            >
              <i className="ri-trophy-line" />
              查看悬赏榜
            </Link>
          </div>
        </div>

        <dl className="mt-14 grid w-full grid-cols-2 gap-x-4 gap-y-6 border-t border-background-200/20 pt-8 md:grid-cols-4 md:gap-6">
          {stats.map((item) => (
            <div key={item.label} className="flex flex-col">
              <dt className="flex items-center gap-2 text-xs text-background-300">
                <i className={`${item.icon} text-accent-400`} />
                {item.label}
              </dt>
              <dd className="mt-2 font-heading text-xl font-bold text-background-50 md:text-2xl">{item.value}</dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="relative flex w-full items-center gap-4 overflow-hidden border-t border-background-200/20 bg-foreground-950/70 py-3">
        <span className="ml-4 flex shrink-0 items-center gap-2 rounded-md bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
          <i className="ri-alarm-warning-line" />
          最新征集
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track flex w-max gap-10 whitespace-nowrap">
            {[...tickerItems, ...tickerItems].map((text, idx) => (
              <span key={`${text}-${idx}`} className="text-xs text-background-200">
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}